<template>
    <div class="module">
        <helpinfo :helpData="helpData" />
        <div class="tooltips"
             style="float: right;margin: -35px 110px 0 0">
            <template>
                <Button v-if="!judgeEditStatus()"
                        type="error"
                        size="small"
                        :disabled="isLoading || baseInfo.status === 'stopped' || !this.hasPermission('CB0103')"
                        @click="hostAction('stop')"
                        class="mar-right3">
                    <Icon class="rc-va-middle"
                          type="md-power" />
                    <span class="rc-va-middle">{{$i18n.t('停止')}}</span>
                </Button>
                <Button v-if="!judgeEditStatus()"
                        size="small"
                        :disabled="isLoading || baseInfo.status !== 'running' || !this.hasPermission('CB0104')"
                        @click="hostAction('restart')"
                        class="mar-right3">
                    <Icon class="rc-va-middle"
                          type="md-refresh" />
                    <span class="rc-va-middle">{{$i18n.t('重启')}}</span>
                </Button>
            </template>
        </div>
        <div class="module-container">
            <serverDetails ref="serverDetails"
                           :isLocak="isLocak"
                           :baseInfo="baseInfo"
                           :id='baseInfo.cloudEnvId'
                           :envType='baseInfo.cloudEnvType'
                           :envName="baseInfo.cloudEnvName"
                           :quote="compType"
                           :operType="operType"
                           :isNoPer="isNoPer"
                           @update="init" />
        </div>
        <!-- 查看tab -->
        <Drawer :closable="true"
                :class="this.tableName === 'log' ? 'log-drawer' : ''"
                :width="60"
                :title="$t(currentTabName)"
                v-model="showDramTap"
                @on-close="cancel">
            <div :style="this.tableName === 'log' ? 'width:100%;height:100%;background: #242424;' : ''"
                 v-if="showDramTap">
                <component :is="this.tableName"
                           :ref="this.tableName"
                           :isLocak="isLocak"
                           :baseInfo="baseInfo"
                           :id='baseInfo.cloudEnvId'
                           :envType='baseInfo.cloudEnvType'
                           :envName="baseInfo.cloudEnvName"
                           :quote="compType"
                           @update="init"></component>
            </div>
        </Drawer>
    </div>
</template>
<script>
import { mgtConstant } from '@/service/constant'
import { hostConstant } from '@/service/hostConstant.js'
import helpinfo from '@c/basic/helpinfo'
import serverDetails from '@c/basic/serverDetails/serverDetails'

import harddisk from '@c/basic/hosttab/harddisk'
import intsnapshot from '@c/basic/hosttab/intsnapshot'
import scriptdetail from '@c/basic/hosttab/scriptdetail'
import securityGroup from '@c/basic/hosttab/securityGroup'
import paramConfig from '@c/basic/hosttab/paramConfig'
import log from '@c/basic/hosttab/log'
import task from '@c/basic/hosttab/task'
import history from '@c/basic/hosttab/history'
import detaildocker from '@c/basic/hosttab/detaildocker'
// import basicmonitor from '@/views/components/biz/monitorecharts/basicmonitor'
import API from '@/service/api.js'
export default {
    name: 'hostdetail',
    components: {
        helpinfo,
        serverDetails,
        harddisk,
        intsnapshot,
        scriptdetail,
        securityGroup,
        paramConfig,
        log,
        task,
        history,
        detaildocker
        // instanceoper
    },
    data () {
        // const isBssAdmin = this.$store.state.user.currentUser.isBssAdmin
        return {
            helpData: {
                modelName: this.$t('主机详情'),
                showBack: true
            },
            isLoading: true,
            // isBssAdmin,
            hostId: this.$route.params.id,
            baseInfo: {},
            initTab: '',
            operType: { type: '', disabled: false },
            isLocak: false,
            compType: 'host', // 传递给组件的参数用于组件判别引用来源
            choosed: [],
            tabsMap: {},
            tableName: this.$route.query.tableName ? this.$route.query.tableName : 'serverDetails',
            currentTabName: '', // 抽屉对应显示
            showDramTap: false
        }
    },
    computed: {
        isRemotePer () {
            return this.baseInfo.lockStatus === 'locked' || !(this.baseInfo.status === 'running' || this.baseInfo.status === 'failure')
        }
    },
    created () {
        this.hostType = this.$route.query.hostType || null
        this.initTab = this.$route.query.tab
        this.init()
    },
    methods: {
        // 判断更多操作是否没有权限
        isNoPer (item) {
            let quote = this.$route.query.quote || 'host'
            quote = quote === 'source' ? 'host' : quote
            const pers = hostConstant.tooltipPermisson[quote] || {}
            const per = pers[item.click]
            return !(per && this.hasPermission(per))
        },
        // 获取主机详情
        init (name) {
            if (name) {
                this.changeFun(name)
            } else {
                this.axios.get(this.urlFormat(`${API.GET_VMS}/${this.hostId}`, true)).then(res => {
                    this.baseInfo = res
                    this.helpData.modelName = '主机详情 - ' + res.instanceName
                    // 获取密码
                    this.axios.get(this.urlFormat(API.GET_HOSTS_ACCOUNT, true, [this.baseInfo.id])).then(res => {
                        this.baseInfo.managemenPassword = res.managemenPassword ? this.$decrypt(res.managemenPassword) : ''
                    })
                    this.baseInfo.objType = 'host'
                    this.isLocak = res.lockStatus === 'locked'
                    const result = []
                    result.push(this.baseInfo)
                    this.choosed = result
                    // 不同云环境生成不同tabsList todo 权限控制
                    this.tabsMap = mgtConstant.initHostTabData(this.baseInfo)
                    if (this.initTab) {
                        this.changeFun(this.initTab)
                        this.initTab = ''
                    }
                    this.isLoading = false
                })
            }
        },
        changeFun (name) {
            if (name === 'basicmonitor') {
                this.$router.push({
                    path: '/mgt/host/monitor/overview/' + this.baseInfo.id,
                    query: {
                        cloudEnvType: this.baseInfo.cloudEnvType,
                        cloudEnvId: this.baseInfo.cloudEnvId,
                        name: this.baseInfo.instanceName
                    }
                })
                return
            }
            if (this.tabsMap[name].show) {
                this.tableName = name
                for (const i in this.tabsMap) {
                    if (i === name) {
                        this.currentTabName = this.tabsMap[i].name
                        break
                    }
                }
                this.showDramTap = true
            }
        },
        // 判断主机状态是否可编辑
        judgeEditStatus () {
            if (this.baseInfo.status === 'pending' || this.baseInfo.status === 'create_failure') {
                return true
            }
            return false
        },
        hostAction (type) {
            this.isLoading = true
            const actionName = type === 'start' ? this.$t('启动') : type === 'restart' ? this.$t('重启') : type === 'stop' ? this.$t('停止') : ''
            const content = this.$t(`您确定${actionName}所选实例吗？`)
            const ids = this.hostId
            this.$Modal.confirm({
                content,
                title: actionName,
                onOk: () => {
                    this.axios.put(this.urlFormat(`${API.GET_VMS}/action/${type}?ids=${ids}&&isStopCharging=false`, true))
                        .then(() => {
                            this.init()
                        })
                }
            })
        },
        cancel () {
            this.showDramTap = false
        }
    }
}
</script>
<style lang="less">
.log-drawer {
    div.ivu-drawer-header {
        background: #242424;
        border-bottom: 1px solid #383737;
        .ivu-drawer-header-inner {
            color: #fff;
        }
    }
    div.ivu-drawer-body {
        padding: 0;
        .no-log {
            line-height: 300px;
            background-color: transparent;
            color: #ccc;
            text-align: center;
            font-size: 20px;
        }
    }
}
</style>
